import withLazyAndSuspense from '../../../utils/lazy';
import DORMANCY_URL_CONSTANTS from '../data/URLConstants';

const dormancyRemoval = withLazyAndSuspense(() => import('../rekyc'));

const dormancySuccess = withLazyAndSuspense(() => import('../rekycSuccess'));

const dormancyError = withLazyAndSuspense(() => import('../error.web'));

const dormacyRemovalHome = withLazyAndSuspense(() => import('../main.web'));

const dormancyRemovalData = withLazyAndSuspense(() => import('../data.web'));

const DormanyRemovalRouteMap = {
  dormancyRemoval: {
    component: dormancyRemoval,
    path: DORMANCY_URL_CONSTANTS.DORMANCY_REMOVAL,
  },
  dormancySuccess: {
    component: dormancySuccess,
    path: DORMANCY_URL_CONSTANTS.DORMANCY_REMOVAL_SUCCESS,
  },
  dormacyRemovalHome: {
    component: dormacyRemovalHome,
    path: DORMANCY_URL_CONSTANTS.DORMANCY_REMOVAL_HOME,
  },
  dormancyRemovalData: {
    component: dormancyRemovalData,
    path: DORMANCY_URL_CONSTANTS.DORMANCY_REMOVAL_DATA,
  },
  dormancyError: {
    component: dormancyError,
    path: DORMANCY_URL_CONSTANTS.DORMANCY_REMOVAL_ERROR_REDIRECT,
  },
};

export default DormanyRemovalRouteMap;
